module.exports = __webpack_public_path__ + "static/media/chat.9e77f9d4.png";